import React, { useEffect, useState } from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../../Shared/Lex'
import { Store } from 'react-notifications-component'

const NewJournalEntry = props => {
  const goalId = props.goalId
  const taskId = props.taskId
  const key = `new-journal-entry-${goalId}-${taskId}`
  const [saveEnabled, setSaveEnabled] = useState(false)
  const [value, setValue] = useState(null)
  const form = {}

  const save = () => {
    props.saveNewJournalEntry(form.comment?.value, () => {
      Store.addNotification({
        title: 'JournalEntry...',
        message: form.comment.value,
        type: 'default',
        insert: 'bottom',
        container: 'bottom-left',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })

      form.comment.value = ''

      localStorage.removeItem(key)

      hide()
    })
  }
  const loadLocalStorage = () => {
    if (localStorage.getItem(key)) { setValue(localStorage.getItem(key)) }
  }

  useEffect(() => {
    loadLocalStorage()
    if (value) {
      if (!saveEnabled) setSaveEnabled(true)
    } else {
      if (saveEnabled) setSaveEnabled(false)
    }
  })

  const saveLocalStorage = () => {
    if (form.comment?.value) {
      localStorage.setItem(key, form.comment?.value)
      if (!saveEnabled) setSaveEnabled(true)
    } else {
      localStorage.removeItem(key)
      if (saveEnabled) setSaveEnabled(false)
    }
  }

  const hide = () => props.hideNewJournalEntry()

  return (
    <div className="cbs-scope border1 rounded5px margin-bottom-5px">
      <div className="margin-top-5px text-right">
        <div className="inline-block">
          <i className="icon-button margin-right margin-top-0-5 fas fa-tags" />
          <i className="icon-button margin-right margin-top-0-5 fas fa-xmark" onClick={hide} />
        </div>
      </div>
      <div className="margin-top-5px">
        <Input
          innerRef={el => form.comment = el} placeholder="Journal Entry" defaultValue={value}
          onChange={saveLocalStorage}
        />
      </div>
      <div className="text-right margin5">
        <Button size="sm" color="success" onClick={save} disabled={!saveEnabled}><Lex term="save" /></Button>
      </div>
    </div>)
}

export default withUserStore(NewJournalEntry)
